import React from 'react';
import { Wheat, Truck, Users, Heart, ShieldCheck, Home } from 'lucide-react';
import { valueProps } from '../../data/mockData';

const iconMap = {
  wheat: Wheat,
  truck: Truck,
  users: Users,
  heart: Heart,
  shield: ShieldCheck,
  home: Home,
};

const WhatWeOffer = () => {
  return (
    <section className="py-24 bg-[#2D5016]/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-[#2D5016]/10 text-[#2D5016] text-xs font-semibold uppercase tracking-wider mb-4">
            Our Values
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3B2F1E] mb-4">
            What We Offer
          </h2>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {valueProps.map((prop, index) => {
            const Icon = iconMap[prop.icon];
            return (
              <div
                key={prop.id}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl bg-[#2D5016]/10 flex items-center justify-center mb-6 group-hover:bg-[#2D5016] transition-colors duration-300">
                  <Icon className="w-8 h-8 text-[#2D5016] group-hover:text-white transition-colors duration-300" />
                </div>

                {/* Content */}
                <h3 className="font-serif text-xl font-bold text-[#3B2F1E] mb-3">
                  {prop.title}
                </h3>
                <p className="text-[#3B2F1E]/70 leading-relaxed">
                  {prop.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
